module.exports = __webpack_public_path__ + "static/img/homepagePic.1252872.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/newLoginPage/homepagePic.png
// module id = ajVT
// module chunks = 96